module.exports = __webpack_public_path__ + "static/media/empty_data.ea06f1fa.png";